// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LrJU","colBig":"styles_colBig__2LtPD","colSmall":"styles_colSmall__2N1zD","shopifyNameWrapper":"styles_shopifyNameWrapper__3Rz4t"};